var _line, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFormula(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-pi",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 9,
    x2: 9,
    y1: 4,
    y2: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7c0-1.7 1.3-3 3-3h13"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20c-1.7 0-3-1.3-3-3V4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormula);
export default __webpack_public_path__ + "static/media/formula.d173c71e5ec5f571ccb7d87d60638ba1.svg";
export { ForwardRef as ReactComponent };